import React from "react";
import CclDrawer from "../../../../../../../components/common/cclDrawer/cclDrawer";
import CclDrawerActionBar from "../../../../../../../components/common/cclDrawer/cclDrawerActionBar";
import CclButton from "../../../../../../../components/common/cclButtons/cclButton";
import { Alert, Box, Stack } from "@mui/material";
import { ParticipantInstrumentStatus } from "../../../../../../../services/types/enterpriseParticipantApiTypes";
import SingleAssessmentStatusDataGridNew from "./singleAssessmentStatusDataGridNew";

export type AdditionalAssessmentsDrawerNewProps = {
    open: boolean;
    onClose: () => void;
    esiKey: number;
    additionalInstruments: ParticipantInstrumentStatus[];
};

const AdditionalAssessmentsDrawerNew: React.FC<AdditionalAssessmentsDrawerNewProps> = (props) => {
    return (
        <CclDrawer
            open={props.open}
            onClose={props.onClose}
            title="Additional Assessments"
            width={"wide"}
        >
            <Box width="100%" height="100%">
                {props.additionalInstruments && props.additionalInstruments.length > 0 ? (
                    <Stack spacing={5} direction="column">
                        {props.additionalInstruments
                            .filter((i) => i.selfAssessmentStatusTypeId !== 5)
                            .map((i) => (
                                <SingleAssessmentStatusDataGridNew
                                    assessment={i}
                                    isLoading={false}
                                />
                            ))}
                    </Stack>
                ) : (
                    <Alert severity="info">No additional assessments for this participant</Alert>
                )}
            </Box>
            <CclDrawerActionBar>
                <CclButton onClick={props.onClose} mode={"primary"}>
                    Close
                </CclButton>
            </CclDrawerActionBar>
        </CclDrawer>
    );
};

export default AdditionalAssessmentsDrawerNew;
